exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handle-document_wrapper .document-upload-step .document-upload-actions .spinner {\n  padding: 0;\n  -webkit-transform: scale(0.5);\n          transform: scale(0.5);\n}\n.handle-document_icr-modal .handle-document_icr-modal_title {\n  font-family: \"latobold\", sans-serif;\n}\n.handle-document_icr-modal .spinner {\n  -webkit-transform: scale(1.5);\n          transform: scale(1.5);\n}", ""]);

// exports
